<script setup lang="ts">
import { defineAsyncComponent, computed, defineOptions } from '#imports'

interface Props {
  type: string | number
}

const props = defineProps<Props>()

const is = computed(() => {
  switch (`${props.type}`) {
    case '1':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle1.vue'))
    case '2':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle2.vue'))
    case '3':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle3.vue'))
    case '4':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle4.vue'))
    case '5':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle5.vue'))
    case '6':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle6.vue'))
    case '7':
      return defineAsyncComponent(() => import('./YscIconsTypeVehicle7.vue'))
  }
  return undefined
})

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <div>
    <component
      :is="is"
      v-bind="$attrs"
    />
  </div>
</template>
